module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_item_message":{"none":"商品がありません。","filtered":"条件に合う商品がありません。"}}}')
  delete Component.options._Ctor
}
